import { useMutation, useQueryClient } from "@tanstack/react-query";
import { togglePodcastBookmark, togglePodcastLike } from "../services/podcastFeedbackService";

function updatePodcast(currentData, podcastId, updater) {
  if (!currentData?.podcasts) return currentData;
  return { ...currentData, podcasts: currentData.podcasts.map((podcast) => Number(podcast.id) === Number(podcastId) ? updater(podcast) : podcast) };
}

export function usePodcastListActions(queryParams = {}) {
  const queryClient = useQueryClient();
  const queryKey = ["podcastList", queryParams];
  const bookmarkMutation = useMutation({
    mutationFn: togglePodcastBookmark,
    onMutate: async ({ audio_podcast_id: podcastId }) => {
      await queryClient.cancelQueries({ queryKey });
      const previousData = queryClient.getQueryData(queryKey);
      queryClient.setQueryData(queryKey, (data) => updatePodcast(data, podcastId, (podcast) => ({ ...podcast, isBookmarked: !podcast.isBookmarked })));
      return { previousData };
    },
    onError: (_error, _variables, context) => context?.previousData && queryClient.setQueryData(queryKey, context.previousData),
    onSuccess: ({ payload }, { audio_podcast_id: podcastId }) => queryClient.setQueriesData({ queryKey: ['podcastList'] }, (data) => updatePodcast(data, podcastId, (podcast) => ({ ...podcast, isBookmarked: Number(payload?.bookmark_status || 0) === 1 }))),
  });
  const likeMutation = useMutation({
    mutationFn: togglePodcastLike,
    onMutate: async ({ audio_podcast_id: podcastId }) => {
      await queryClient.cancelQueries({ queryKey });
      const previousData = queryClient.getQueryData(queryKey);
      queryClient.setQueryData(queryKey, (data) => updatePodcast(data, podcastId, (podcast) => {
        const isLiked = !podcast.isLiked;
        return { ...podcast, isLiked, likeCount: Math.max(0, Number(podcast.likeCount || 0) + (isLiked ? 1 : -1)) };
      }));
      return { previousData };
    },
    onError: (_error, _variables, context) => context?.previousData && queryClient.setQueryData(queryKey, context.previousData),
    onSuccess: ({ payload }, { audio_podcast_id: podcastId }) => queryClient.setQueriesData({ queryKey: ['podcastList'] }, (data) => updatePodcast(data, podcastId, (podcast) => ({ ...podcast, isLiked: Number(payload?.like_status || 0) === 1, likeCount: Number(payload?.total_liked || 0) }))),
  });
  return { toggleBookmark: bookmarkMutation, toggleLike: likeMutation };
}
